'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { extractProps } from '../../utils/extract-props.js';
import { Flex } from '../layout/index.js';
import { useSideNavigation } from './side-navigation.store.js';
import { sideNavigationContentPropDefs } from './side-navigation.props.js';
const SideNavigationContent = forwardRef((props, forwardedRef) => {
    const { className, children, expandedWidth, collapsedWidth, ...otherProps } = extractProps(props, sideNavigationContentPropDefs);
    const { expanded } = useSideNavigation();
    return (_jsx(Flex, { ref: forwardedRef, width: expanded ? expandedWidth : collapsedWidth, minWidth: expanded ? expandedWidth : collapsedWidth, className: twMerge('rt-SideNavigationContent', 'bg-neutral-surface', className), ...otherProps, children: children }));
});
SideNavigationContent.displayName = 'SideNavigation.Content';
export { SideNavigationContent };
//# sourceMappingURL=side-navigation-content.js.map